import { Link } from "react-router-dom";
import { asset, formatUSD } from "../lib/api";
import { Film, ArrowUpRight } from "lucide-react";

export const TimelapseCard = ({ tl, index = 0 }) => (
  <Link
    to={`/timelapse/${tl.slug || tl.id}`}
    data-testid={`timelapse-card-${tl.id}`}
    className="group relative block overflow-hidden rounded-lg border border-white/10 bg-obsidian-800 animate-fade-up"
    style={{ animationDelay: `${index * 60}ms` }}
  >
    <div className="aspect-[4/3] overflow-hidden">
      {tl.thumbnail_url ? (
        <img src={asset(tl.thumbnail_url)} alt={tl.title} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
      ) : <div className="w-full h-full bg-obsidian-700" />}
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
    <div className="absolute top-3 left-3 flex items-center gap-1.5 glass rounded-full px-2.5 py-1">
      <Film size={12} className="text-amber-glow" />
      <span className="font-mono text-[0.62rem] tracking-wider">{tl.frame_count} FR</span>
    </div>
    <div className="absolute bottom-0 inset-x-0 p-5">
      <div className="overline-label mb-1">{tl.category} · {tl.location}</div>
      <div className="flex items-end justify-between">
        <h3 className="font-serif text-2xl font-light leading-tight">{tl.title}</h3>
        <ArrowUpRight className="text-amber-glow opacity-0 group-hover:opacity-100 transition-opacity -translate-y-1 group-hover:translate-y-0 duration-300" size={22} />
      </div>
      <div className="mt-2 text-xs text-neutral-400">
        License from {formatUSD(tl.personal_price)} · Prints available
      </div>
    </div>
  </Link>
);
